import React from "react";
import Text from "@amzn/meridian/text";
import { FormattedMessage } from "react-intl";
import Column from "@amzn/meridian/column";
import Box from "@amzn/meridian/box";

const BoxMetricViewV2 = (props) => {
  return (
    <Box type="outline" spacingInset={"medium"}>
      <Column spacingInset={"none"}>
        <Text type="h200">
          <FormattedMessage
            id={props.data.headerId}
            defaultMessage={props.data.defaultHeader}
          />
        </Text>
        <Column spacing="small">
          <Text type="d50">{props.data.value}</Text>
          <Text type="b300" color={"secondary"}>
            <FormattedMessage
              id={props.data.footerId}
              defaultMessage={props.data.defaultFooter}
            />
          </Text>
        </Column>
      </Column>
    </Box>
  );
};

export default BoxMetricViewV2;



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/BoxMetricViewV2.js